<template>
  <div class="content-editor-block image">

    <el-upload
      v-loading="isProcessingImage"
      ref="elupload"
      accept="image/*"
      class="image-uploader"
      drag
      action=""
      :auto-upload="true"
      :http-request="processFile">
      <img v-show="localBlobURL||mValue.img" @load="onLoaded" class="preview" :src="localBlobURL||mValue.img"/>
      <i v-show="!(localBlobURL||mValue.img)" class="el-icon-upload"></i>
      <div class="el-upload__text">將文件拖曳至此，或<em>點擊上傳</em></div>
    </el-upload>
    <p>下方可上傳手機版圖片(非必填)</p>
    <el-upload
      v-loading="mobileImage.isProcessingImage"
      ref="mobImg_elupload"
      accept="image/*"
      class="image-uploader"
      drag
      action=""
      :auto-upload="true"
      :http-request="mobImg_processFile">
      <img v-show="mobileImage.localBlobURL||mValue.mobImg" @load="mobImg_onLoaded" class="preview" :src="mobileImage.localBlobURL||mValue.mobImg"/>
      <i v-show="!(mobileImage.localBlobURL||mValue.mobImg)" class="el-icon-upload"></i>
      <div class="el-upload__text">將文件拖曳至此，或<em>點擊上傳</em></div>
    </el-upload>
    <el-input
      v-for="(additionalColumn,idx) in additionalColumns"
      :key="`image-editor-additional-column-${idx}`"
      v-model="mValue[additionalColumn.key]" @input="onInput"
      :placeholder="additionalColumn.placeholder"
      :style="(idx !== additionalColumns.length-1) ? 'border-bottom: 1px solid #eee;' : ''">
      <template slot="prepend">{{additionalColumn.prepend}}</template>
    </el-input>

  </div>
</template>

<script>
import ImageThumbnailer from '@/utils/ImageThumbnailer.js'
export default {
  props: {
    value: {
      default: () => {
        return {
          title: '',
          alt: '',
          img: null
        }
      }
    },
    additionalColumns: {
      default: () => {
        return [
          {
            key: 'alt',
            placeholder: '請輸入圖片SEO名稱',
            prepend: '名稱'
          },
          {
            key: 'title',
            placeholder: '請輸入圖片敘述',
            prepend: '敘述'
          },
          {
            key: 'url',
            placeholder: '請輸入連結網址',
            prepend: '網址'
          }
        ]
      }
    }
  },
  data: () => {
    return {
      mValue: {},
      localBlobURL: '',
      isProcessingImage: false,
      isLocalBlobJustLoaded: false,
      // 手機版
      mobileImage: {
        isProcessingImage: false,
        isLocalBlobJustLoaded: false,
        localBlobURL: ''
      }
    }
  },
  computed: {},
  methods: {
    processFile (e) {
      let isImg = e.file.type.indexOf('image') >= 0
      if (!isImg) return alert('請上傳圖片檔案')
      var imageCompressFormat = 'image/jpeg'
      if (e.file.type === 'image/gif') {
        imageCompressFormat = 'image/gif'
      }
      this.isProcessingImage = true
      this.$refs.elupload.clearFiles()
      // 壓縮 image
      let imageCompressPromise = new Promise((resolve, reject) => {
        if (imageCompressFormat === 'image/gif') {
          // gif就不要壓縮
          resolve(e.file)
          return
        }
        let opts = {
          maxWidth: 1920,
          maxHeight: 1920,
          format: imageCompressFormat
        }
        ImageThumbnailer.shared.requestCompress(
          e.file,
          blob => {
            resolve(blob)
          },
          opts
        )
      })
      // 壓縮thumb
      let thumbCompressPromise = new Promise((resolve, reject) => {
        let opts = {
          maxWidth: 192,
          maxHeight: 192,
          format: imageCompressFormat
        }
        ImageThumbnailer.shared.requestCompress(
          e.file,
          blob => {
            resolve(blob)
          },
          opts
        )
      })

      Promise.all([imageCompressPromise, thumbCompressPromise]).then(
        results => {
          let blob = results[0]
          let thumbBlob = results[1]
          this.onThumb(blob, thumbBlob)
        }
      )
      // ImageThumbnailer.shared.requestCompress(e.file, this.onThumb)
    },
    onInput () {
      this.$emit('input', this.mValue)
    },
    onThumb (blob, thumbBlob) {
      this.localBlobURL = URL.createObjectURL(blob)
      this.isLocalBlobJustLoaded = true
      this.mValue.img = blob
      this.mValue.thumb = thumbBlob

      const uploadBlobs = () => {
        this.isProcessingImage = true

        let imagePrefix = 'image-editor-'
        let thumbPrefix = 'image-editor-thumb-'

        let promise1 = this.$services.firebase.upload(
          this.mValue.img,
          imagePrefix
        )
        let promise2 = this.$services.firebase.upload(
          this.mValue.thumb,
          thumbPrefix
        )

        Promise.all([promise1, promise2]).then(urls => {
          let imageUrl = urls[0]
          let thumbUrl = urls[1]
          this.mValue.img = imageUrl
          this.mValue.thumb = thumbUrl
          this.localBlobURL = ''
          this.$emit('input', this.mValue)
          this.isProcessingImage = false
        })
      }
      uploadBlobs()
    },
    onLoaded (evt) {
      if (this.isLocalBlobJustLoaded) {
        this.isLocalBlobJustLoaded = false
        URL.revokeObjectURL(evt.target.src)
      }
    },

    mobImg_processFile (e) {
      let isImg = e.file.type.indexOf('image') >= 0
      if (!isImg) {
        alert('請上傳圖片檔案')
        return
      }
      var imageCompressFormat = 'image/jpeg'
      if (e.file.type === 'image/gif') {
        imageCompressFormat = 'image/gif'
      }
      this.mobileImage.isProcessingImage = true
      this.$refs.mobImg_elupload.clearFiles()
      // 壓縮 image
      let imageCompressPromise = new Promise((resolve, reject) => {
        if (imageCompressFormat === 'image/gif') {
          // gif就不要壓縮
          resolve(e.file)
          return
        }
        let opts = {
          maxWidth: 1080,
          maxHeight: 1920,
          format: imageCompressFormat
        }
        ImageThumbnailer.shared.requestCompress(
          e.file,
          blob => {
            resolve(blob)
          },
          opts
        )
      })
      // 壓縮thumb
      let thumbCompressPromise = new Promise((resolve, reject) => {
        let opts = {
          maxWidth: 192,
          maxHeight: 192,
          format: imageCompressFormat
        }
        ImageThumbnailer.shared.requestCompress(
          e.file,
          blob => {
            resolve(blob)
          },
          opts
        )
      })

      Promise.all([imageCompressPromise, thumbCompressPromise]).then(
        results => {
          let blob = results[0]
          let thumbBlob = results[1]
          this.mobImg_onThumb(blob, thumbBlob)
        }
      )
      // ImageThumbnailer.shared.requestCompress(e.file, this.onThumb)
    },
    mobImg_onThumb (blob, thumbBlob) {
      this.localBlobURL = URL.createObjectURL(blob)
      this.isLocalBlobJustLoaded = true
      this.mValue.mobImg = blob
      this.mValue.mobThumb = thumbBlob

      const uploadBlobs = () => {
        this.mobileImage.isProcessingImage = true

        let imagePrefix = 'image-editor-mob-img-'
        let thumbPrefix = 'image-editor-mob-thumb-'

        let promise1 = this.$services.firebase.upload(
          this.mValue.mobImg,
          imagePrefix
        )
        let promise2 = this.$services.firebase.upload(
          this.mValue.mobThumb,
          thumbPrefix
        )

        Promise.all([promise1, promise2]).then(urls => {
          let imageUrl = urls[0]
          let thumbUrl = urls[1]
          this.mValue.mobImg = imageUrl
          this.mValue.mobThumb = thumbUrl
          this.mobileImage.localBlobURL = ''
          this.$emit('input', this.mValue)
          this.mobileImage.isProcessingImage = false
        })
      }
      uploadBlobs()
    },
    mobImg_onLoaded (evt) {
      if (this.mobileImage.isLocalBlobJustLoaded) {
        this.mobileImage.isLocalBlobJustLoaded = false
        URL.revokeObjectURL(evt.target.src)
      }
    }
  },
  beforeDestroy () {
    ImageThumbnailer.shared.cancelCompressRequest(this.onThumb)
  },
  created () {
    this.mValue = this.value
  },
  watch: {
    value () {
      this.mValue = this.value
    }
  }
}
</script>
